class HeroSlider {
  constructor() {
    this.slider = document.querySelector('.jsHeroSlider');
    this.track = document.querySelector('.jsTrack');
    this.items = document.querySelectorAll('.jsItem');
    this.prevButton = document.querySelector('.jsPrev');
    this.nextButton = document.querySelector('.jsNext');
    this.cursor = document.querySelector('.jsCursor');
    this.cursorOuter = document.querySelector('.jsCursorOuter');
    this.cursorProgress = document.querySelector('.jsCursorProgressCircle');
    this.cursorInner = document.querySelector('.jsCursorInner');
    this.arrows = document.querySelectorAll('.jsArrow');
    
    this.currentIndex = 0;
    this.isAnimating = false;
    this.autoPlayInterval = null;
    this.autoPlayDelay = parseInt(this.slider?.dataset.autoplayDelay) || 6000;
    this.autoPlayEnabled = this.slider?.dataset.autoplayEnabled === 'true';
    
    this.init();
  }
  
  init() {
    if (!this.slider) return;
    
    this.setupEventListeners();
    this.setupInitialState();
    if (this.autoPlayEnabled) {
      this.startAutoPlay();
    }
    this.setupCursor();
  }
  
  setupEventListeners() {
    if (this.prevButton) {
      this.prevButton.addEventListener('click', () => this.prevSlide());
    }
    
    if (this.nextButton) {
      this.nextButton.addEventListener('click', () => this.nextSlide());
    }
    
    document.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') this.prevSlide();
      if (e.key === 'ArrowRight') this.nextSlide();
    });
    
    this.setupTouchEvents();
    this.setupCursorEvents();
  }
  
  setupTouchEvents() {
    let startX = 0;
    let startY = 0;
    let endX = 0;
    let endY = 0;
    
    this.slider.addEventListener('touchstart', (e) => {
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
    });
    
    this.slider.addEventListener('touchend', (e) => {
      endX = e.changedTouches[0].clientX;
      endY = e.changedTouches[0].clientY;
      
      const deltaX = endX - startX;
      const deltaY = endY - startY;
      
      if (Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > 50) {
        if (deltaX > 0) {
          this.prevSlide();
        } else {
          this.nextSlide();
        }
      }
    });
  }
  
  setupCursorEvents() {
    if (!this.cursor) return;
    
    this.slider.addEventListener('mousemove', (e) => {
      const rect = this.slider.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;
      
      this.cursor.style.left = x + 'px';
      this.cursor.style.top = y + 'px';
      this.cursor.style.display = 'block';
      this.cursor.style.transform = 'translate(-50%, -50%)';
    });
    
    this.slider.addEventListener('mouseleave', () => {
      this.cursor.style.display = 'none';
    });
  }
  
  setupInitialState() {
    if (!this.items || this.items.length === 0) return;
    
    // 最初のスライドをアクティブに
    this.currentIndex = 0;
    this.updateSlide();
    
    // スライダーの表示を確実に
    if (this.track) {
      this.track.style.opacity = '1';
    }

    // 進行状況トラックの表示を初期化
    if (this.cursor) {
      this.cursor.style.opacity = '1';
    }
  }
  
  setupCursor() {
    if (!this.cursor) return;
    
    this.cursor.style.display = 'none';
    this.cursor.style.position = 'absolute';
    this.cursor.style.pointerEvents = 'none';
    this.cursor.style.zIndex = '10';
  }
  
  nextSlide() {
    if (this.isAnimating) return;
    
    this.currentIndex = (this.currentIndex + 1) % this.items.length;
    this.updateSlide();
  }
  
  prevSlide() {
    if (this.isAnimating) return;
    
    this.currentIndex = this.currentIndex === 0 ? this.items.length - 1 : this.currentIndex - 1;
    this.updateSlide();
  }
  
  updateSlide() {
    this.isAnimating = true;
    
    this.items.forEach(item => {
      item.classList.remove('isActive', 'prev', 'next', 'far-prev', 'far-next', 'hidden', 'far-hidden');
    });
    
    const totalItems = this.items.length;
    
    this.items.forEach((item, index) => {
      let relativeIndex = index - this.currentIndex;
      
      if (relativeIndex > totalItems / 2) {
        relativeIndex -= totalItems;
      } else if (relativeIndex < -totalItems / 2) {
        relativeIndex += totalItems;
      }
      
      if (relativeIndex === 0) {
        item.classList.add('isActive');
      } else if (relativeIndex === -1) {
        item.classList.add('prev');
      } else if (relativeIndex === 1) {
        item.classList.add('next');
      } else if (relativeIndex === -2) {
        item.classList.add('far-prev');
      } else if (relativeIndex === 2) {
        item.classList.add('far-next');
      } else if (Math.abs(relativeIndex) === 3) {
        item.classList.add('hidden');
      } else {
        item.classList.add('far-hidden');
      }
    });
    
    this.updateCursorProgress();
    
    setTimeout(() => {
      this.isAnimating = false;
    }, 1000);
  }
  
  updateCursorProgress() {
    if (!this.cursorProgress) return;
    
    const progress = ((this.currentIndex + 1) / this.items.length) * 100;
    const circumference = 2 * Math.PI * 30;
    const strokeDasharray = `${(progress / 100) * circumference} ${circumference}`;
    
    this.cursorProgress.style.strokeDasharray = strokeDasharray;
  }
  
  startAutoPlay() {
    this.pauseAutoPlay();
    this.autoPlayInterval = setInterval(() => {
      this.nextSlide();
    }, this.autoPlayDelay);
  }
  
  pauseAutoPlay() {
    if (this.autoPlayInterval) {
      clearInterval(this.autoPlayInterval);
      this.autoPlayInterval = null;
    }
  }
}

function initHeroSlider() {
  const sliderElement = document.querySelector('.jsHeroSlider');
  if (sliderElement) {
    new HeroSlider();
  }
}

document.addEventListener('DOMContentLoaded', initHeroSlider);

// Shopifyカスタマイザーのイベントを監視
document.addEventListener('shopify:section:load', (event) => {
  if (event.target.querySelector('.jsHeroSlider')) {
    initHeroSlider();
  }
});

document.addEventListener('shopify:section:select', (event) => {
  if (event.target.querySelector('.jsHeroSlider')) {
    initHeroSlider();
  }
});